import fetch from "auth/FetchInterceptor";

const organizationalStructureSimulationService = {};

organizationalStructureSimulationService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/organizational-structure-simulation",
		method: "get",
		params,
	});
};

organizationalStructureSimulationService.getById = function (id) {
	return fetch({
		url: "/v1/rest/organizational-structure-simulation/" + id,
		method: "get",
	});
};

organizationalStructureSimulationService.put = function (simulation) {
	return fetch({
		url: "/v1/rest/organizational-structure-simulation",
		method: "put",
		data: { simulation },
	});
};

export default organizationalStructureSimulationService;
